export const getUserAgent = state => state.userAgent;
export const getIsMac = state => getUserAgent(state).isMac;



// WEBPACK FOOTER //
// ./app/selectors/user-agent-selectors.js